import {Injectable} from '@angular/core';
import {BaseProvider} from '@providers/base.provider';
import {Resolve} from '@angular/router';
import {skip, take} from 'rxjs/operators';

/**
 * Резолвер, берущий данные из провайдера, заодно обновляющий данные провайдера, если требуется
 */

@Injectable()
export class FromProviderResolverService<T> implements Resolve<T> {

    /**
     * Нужно ли кешировать данные или каждый раз запрашивать новые?
     * @type {boolean}
     */
    protected cacheData = false;

    constructor(
        private _provider: BaseProvider<T>,
    ) {}

    resolve() {
        if (this.cacheData && !this._provider.isFetching && !this._provider.hasError) {
            /**
             * Вернуть нужно значение, либо законченный Observable, иначе повиснет запрос
             */
            return this._provider.data$.getValue();
        }

        if (!this._provider.isFetching || this._provider.hasError) {
            this._provider.updateData();
        }

        /**
         * Пропускаем текущее значение и берем следующее, таким образом получаем данные из провайдера
         */
        return this._provider.data$.pipe(
            skip(1),
            take(1)
        );
    }
}
